type Rect = { x: number; y: number; width: number; height: number };

export const getSquareCropRect = (
  imageWidth: number,
  imageHeight: number,
): Rect => {
  let x = 0;
  let y = 0;
  let width = imageWidth;
  let height = imageHeight;

  if (imageWidth > imageHeight) {
    x = (imageWidth - imageHeight) / 2;
    width = height;
  }
  if (imageHeight > imageWidth) {
    y = (imageHeight - imageWidth) / 2;
    height = width;
  }

  return { x, y, width, height };
};

export const readBlobAsDataURL = (blob: Blob): Promise<string> =>
  new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.onload = async (ev): Promise<void> => {
      if (ev.target) {
        resolve(ev.target.result as string);
      } else {
        reject();
      }
    };
    fileReader.onerror = reject;
    fileReader.readAsDataURL(blob);
  });

export const cropImageToSquare = async (
  dataURL: string,
  minimumSrcSize: number,
  targetSize: number,
): Promise<string> =>
  new Promise((resolve, reject) => {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    if (ctx) {
      const img = new Image();
      img.onload = (): void => {
        if (img.width < minimumSrcSize || img.height < minimumSrcSize) {
          return reject("error.imageTooSmall");
        }

        canvas.width = targetSize;
        canvas.height = targetSize;
        const { x, y, width, height } = getSquareCropRect(
          img.width,
          img.height,
        );
        ctx.drawImage(img, x, y, width, height, 0, 0, targetSize, targetSize);
        resolve(canvas.toDataURL("image/jpeg"));
      };
      img.onerror = (): void => reject("error.imageFailedToRead");
      img.src = dataURL;
    }
  });
